const login = {
    login: 'Login',
    phone: 'Telepon',
    email: 'Email',
    erCode: 'Kode QR',
    phoneNo: 'Nomor Telepon',
    sryx: 'Silakan masukkan email',
    password: 'Kata Sandi',
    wjmm: 'Lupa kata sandi?',
    srmm: 'Silakan masukkan kata sandi',
    myzh: 'Belum punya akun?',
    ljzc: 'Daftar Sekarang',
    cxsm: 'Setelah refresh, gunakan aplikasi Biking untuk memindai kode QR lagi',
    xydl: 'Silakan respon login di ponsel',
    smewm: 'Di aplikasi Biking, klik ikon profil, lalu tekan ikon di kanan atas untuk memindai kode QR',
    qtfs: 'Metode Login Lainnya',
    ggsfyz: 'Verifikasi Google Authenticator',
    bdsj: 'Anda telah mengikat telepon',
    bdyx: 'Anda telah mengikat email',
    fsyzm: 'Kirim Kode Verifikasi',
    wcyz: 'Silakan selesaikan verifikasi',
    dlcg: 'Login berhasil, selamat datang di Biking!',
    bktb: 'Demi keamanan, penarikan aset tidak dapat dilakukan dalam 24 jam setelah mengubah pengaturan keamanan akun',
    fhdl: 'Kembali ke halaman login',
    jx: 'Lanjutkan',
    cxfs: 'Kirim Ulang',
    gxmm: 'Perbarui Kata Sandi',
    srsjh: 'Silakan masukkan nomor telepon',
    wjmm1: 'Lupa Kata Sandi',
    sryxdz: 'Silakan masukkan alamat email',
    srzqyx: 'Silakan masukkan alamat email yang benar',
    sryzm: 'Masukkan kode verifikasi',
    czmm: 'Atur Ulang Kata Sandi',
    sbdyzm: 'Tidak menerima kode verifikasi?',
    srxmm: 'Silakan masukkan kata sandi baru',
    zczh: 'Daftar Akun Biking',
    yqm: 'Kode Undangan (opsional)',
    sryqm: 'Silakan masukkan kode undangan',
    zc: 'Daftar',
    yyzh: 'Sudah punya akun?',
    ljdl: 'Login Sekarang',
    fsz: 'Kode verifikasi telah dikirim ke',
    next: 'Selanjutnya',
    szmm: 'Atur Kata Sandi',
    submit: 'Kirim',
    zccg: 'Pendaftaran Berhasil!'
}
const download = {
    title: 'Platform Game Diversifikasi &<br/>Perdagangan Aset Digital',
    subTitle: 'Biking mendukung perdagangan ratusan aset digital',
    xzbw: 'Mengapa Memilih Biking',
    czzz: 'Biking membantu Anda menciptakan, meningkatkan, dan mengamankan kekayaan',
    download: 'Unduh di App Store',
    downloadtf: 'Unduh di TestFlight',
    cjqxz: 'Unduh Sertifikat Super',
    cjq: 'Sertifikat Super {index}',
    bdxz: 'Unduh Lokal',
    ggpxz: 'Unduh di Google Play',
    advantageTitle1: 'Kinerja Terbaik · Trading Super Cepat',
    subTitleSubTitle1: 'Didukung teknologi London Stock Exchange, latency ultra-rendah, pencocokan super cepat',
    advantageTitle2: 'Perlindungan Aset · Keamanan Maksimal',
    subTitleSubTitle2: 'Biking memenuhi standar CCSS, menjamin keamanan aset dan data',
    advantageTitle3: 'Layanan 24/7',
    subTitleSubTitle3: 'Memastikan sistem berjalan normal, menyediakan layanan pelanggan 24/7',
    qhidxq: 'Detail Penggantian ID',
    step1: 'Langkah 1',
    step2: 'Langkah 2',
    step3: 'Langkah 3',
    step4: 'Langkah 4',
    step5: 'Langkah 5',
    step6: 'Langkah 6',
    step7: 'Langkah 7',
    step8: 'Langkah 8',
    step9: 'Langkah 9',
    step10: 'Langkah 10',
    azBiking: 'Instal Biking melalui App Store',
    dlxz: 'Jika Anda memiliki App ID dari luar Tiongkok Daratan, silakan login langsung ke App Store untuk mengunduh',
    fdlid: 'Siapkan App ID dari luar Tiongkok Daratan',
    yxfshq: 'Jika Anda tidak memiliki App ID dari luar Tiongkok Daratan, Anda dapat mencoba mendapatkannya dengan cara berikut',
    qhid: 'Ganti Apple ID di App Store',
    dk: '1. Buka',
    ysjtx: 'Aplikasi App Store, ketuk avatar di kanan atas App Store',
    cxsrmm: '2. Ketuk "Keluar", lalu masukkan kembali Apple ID dan kata sandi',
    wfdl: '* Jika muncul "Tidak dapat login", mungkin karena Anda terlalu sering mengganti login, coba ganti ID atau coba lagi beberapa jam kemudian. Jika ID terkunci, lakukan verifikasi atau ganti ID',
    azapp: 'Instal Aplikasi',
    storesh: '1. Setelah login berhasil, akan otomatis beralih ke App Store wilayah terkait, cari "Biking" di App Store, ketuk tombol "Get" untuk mulai menginstal aplikasi',
    jxxz: 'Saya punya Apple ID non-Tiongkok Daratan, lanjutkan unduh',
    jxxz1: 'Lanjutkan Unduh',
    way1: 'Cara 1',
    wayTitle1: 'Daftar sendiri, aman dan stabil',
    wayBtn1: 'Lihat cara mendaftar',
    way2: 'Cara 2',
    wayTitle2: 'ID referensi platform (mudah dan cepat)',
    wayBtn2: 'Lihat ID referensi',
    way3: 'Cara 3',
    wayTitle3: 'Panduan negara/wilayah (bebas berganti)',
    wayBtn3: 'Lihat cara membeli',

    ckzh: 'Akun Referensi Apple ID Non-Tiongkok Daratan',
    jgck: 'ID wilayah luar negeri berikut untuk referensi',
    jjfz: '(Ketik akun atau kata sandi untuk menyalin)',
    zh: 'Akun',
    mm: 'Kata Sandi',
    xxxl: 'Untuk mencegah kebocoran informasi ponsel Anda',
    dlicloud: 'Jangan gunakan Apple ID di atas untuk login ke iCloud',
    tczh: 'Setelah mengunduh aplikasi menggunakan Apple ID referensi, segera keluar dari akun tersebut',
    cfsy: 'Jangan hubungkan nomor telepon, agar ID dapat digunakan kembali',
    jrql: 'Pindai kode QR untuk bergabung dengan grup obrolan',
    lxkf: 'Hubungi Layanan Pelanggan',

    zjzc: 'Daftar ID Luar Negeri Sendiri',
    registerStep1: 'Langkah 1 Buka halaman utama appleid',
    registerStep2: 'Langkah 2 Verifikasi email',
    registerStep3: 'Langkah 3 Keluar dari akun App Store',
    registerStep4: 'Langkah 4 Login ke Store dengan ID yang baru didaftarkan',
    gwzcwz: 'Buka situs web pendaftaran resmi Apple di browser Safari:',
    yzdzyx: 'Setelah mengisi semua informasi dan mengeklik "Lanjutkan", Anda akan menerima email verifikasi Apple ID, masukkan kode verifikasi email',
    tjfkfs: 'Kemudian akan otomatis beralih ke halaman manajemen Apple ID (mungkin perlu loading sebentar), setelah masuk ke halaman manajemen, klik "Pembayaran dan Pengiriman", lalu klik "Tambahkan Metode Pembayaran" di halaman berikutnya',
    mgsfzsc: 'Saat yang paling krusial, pastikan metode pembayaran adalah "Tidak", jika "Tidak" jangan diubah; negara/wilayah adalah Amerika Serikat atau wilayah yang ingin Anda daftarkan, konten lainnya dapat diisi sembarang. Namun sebaiknya isi dalam bahasa Inggris, pilih negara bagian Alaska karena bebas pajak, pembelian aplikasi juga bebas pajak. Informasi pribadi spesifik dapat dihasilkan melalui situs web: Pembuatan ID Amerika Serikat',
    gxdqxx: 'Setelah mengisi, klik "Perbarui" untuk memperbarui informasi wilayah',
    zhxx: '1. Masuk ke App Store, ketuk avatar di kanan atas untuk masuk ke halaman akun',
    djwc: '2. Geser halaman ke bawah, ketuk "Keluar" untuk keluar dari ID toko, lalu ketuk "Selesai"',
    jrzhdl: '1. Ketuk lagi avatar di kanan atas untuk masuk ke halaman login akun',
    zhmmdl: '2. Masukkan akun, kata sandi, ketuk "Login" untuk login',
    jydlcg: '3. Masukkan kode verifikasi, setelah berhasil diverifikasi, Apple ID berhasil login',
    jysssd: 'Trading di mana saja, kapan saja',
    smewm: 'Pindai Kode QR',
    xiazai: 'Unduh',
    huodong: 'Aktivitas',
    title1: 'Biking Platform Game Diversifikasi',
    title2: 'dan Perdagangan Aset Digital',
    open: 'Buka di Aplikasi "Biking"',
    ggzx: 'Pusat Pengumuman',
    lscb: 'Deposit On-Chain',
    fbrj: 'Deposit Fiat',
    tgaq: 'Berkomitmen menyediakan layanan',
    wdjmzc: 'produk derivatif aset kripto yang lebih aman dan stabil',
    szhbjy: 'Kami profesional dalam perdagangan aset digital',
    yxhsjh: 'Daftar dengan email/nomor telepon'
}
export { login, download }


// WEBPACK FOOTER //
// ./src/i18n/lang/login/ba.js